import { SafePromise } from '@benzinga/safe-await';
import { IncludeHeader, RestfulClient, Session } from '@benzinga/session';
import { NodeQueryParams, NodeQueryParamsTokenType, News } from '../entities';
import { BasicNewsEnvironment } from '../environment';

export class NodeContentRestful extends RestfulClient {
  constructor(session: Session, includeHeaders?: IncludeHeader) {
    super(session.getEnvironment(BasicNewsEnvironment).nodeContentUrl, session, includeHeaders);
  }

  public fetchNodes = async (params: NodeQueryParams = {}): SafePromise<News[]> => {
    const token = this.session.getEnvironment(BasicNewsEnvironment).nodeContentKey;

    const url = this.URL(`api/v2/news`, {
      channels: params.channels ? params.channels.join(',') : undefined,
      date: params.date,
      dateFrom: params.dateFrom,
      dateTo: params.dateTo,
      displayOutput: params.displayOutput ?? 'headline',
      page: params.page ? params.page : 0,
      pageSize: params.pageSize ? params.pageSize : 15,
      sort: params.sort ? params.sort : 'updated:desc',
      tickers: params.symbols ? params.symbols.join(',') : undefined,
      token: params?.tokenType ? this.getToken(params.tokenType) : token,
      topics: params.topics ? params.topics.join(',') : undefined,
    });
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };

  public getStory = async (id: number): SafePromise<News> => {
    const token = this.session.getEnvironment(BasicNewsEnvironment).nodeContentKey;
    const url = this.URL(`api/v2/news/${id}`, {
      displayOutput: 'full',
      token,
    });

    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };

  private getToken = (key?: NodeQueryParamsTokenType) => {
    const secToken = this.session.getEnvironment(BasicNewsEnvironment).nodeContentSecKey;
    const partnerContentToken = this.session.getEnvironment(BasicNewsEnvironment).partnerContentKey;
    const pressReleaseToken = this.session.getEnvironment(BasicNewsEnvironment).pressReleaseKey;
    const koreaContentKey = this.session.getEnvironment(BasicNewsEnvironment).koreaContentKey;
    const japanContentKey = this.session.getEnvironment(BasicNewsEnvironment).japanContentKey;
    const spainContentKey = this.session.getEnvironment(BasicNewsEnvironment).esContentKey;
    const italyContentKey = this.session.getEnvironment(BasicNewsEnvironment).itContentKey;
    const franceContentKey = this.session.getEnvironment(BasicNewsEnvironment).frContentKey;
    const token = this.session.getEnvironment(BasicNewsEnvironment).nodeContentKey;

    switch (key) {
      case 'sec':
        return secToken;
      case 'partner':
        return partnerContentToken;
      case 'press-release':
        return pressReleaseToken;
      case 'korea':
        return koreaContentKey;
      case 'japan':
        return japanContentKey;
      case 'spain':
        return spainContentKey;
      case 'italy':
        return italyContentKey;
      case 'france':
        return franceContentKey;
      default:
        return token;
    }
  };
}
